import { useQuery } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { TimelineItem } from 'views/Tasks/Timeline/types';
import { normalizeTimelineId } from 'views/Tasks/Timeline/helpers';

export const getTimelines = async (
    { orgId, dealId, includeAssignees = false }: { orgId: string; dealId: number; includeAssignees?: boolean },
): Promise<TimelineItem[]> => {
    const url = includeAssignees
        ? `${API_ENDPOINTS.TIMELINES(orgId, dealId)}?include_assignees=true`
        : API_ENDPOINTS.TIMELINES(orgId, dealId);
    const response = await axiosInstance.get<TimelineItem[]>(url);
    return response.data.map(normalizeTimelineId);
};

export const useGetTimelines = ({ orgId, dealId, includeAssignees = false }: { orgId: string; dealId: number; includeAssignees?: boolean }) => useQuery({
    queryKey: ['timelines', orgId, dealId, includeAssignees],
    queryFn: () => getTimelines({ orgId, dealId, includeAssignees }),
});
